module.exports = __webpack_public_path__ + "static/img/pay-bg.80ed911c.png";